import React, { useState } from 'react';
import { Typography, CardContent, Card, TextField } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { Edit, Save } from '@mui/icons-material';
import { updateAchievement } from 'Api/achievements';
import { IconContaniner, ContainerStyle } from './style';

import styles from '../../Hooks/useStyles';

export default function MyAchievementCard({ id = null, name = '', description = '' }) {
  const t2 = useTranslation('Achievements');
  const textFieldStyles = styles.textFieldStyles();
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [editing, setEditing] = useState(false);
  const [textTitle, setTextTitle] = useState(name);
  const [savedTextTitle, setSavedTextTitle] = useState(name);

  const handleEdit = () => {
    setEditing(!editing);
  };

  const handleSave = () => {
    const trimmedTextTitle = textTitle.trim();
    if (savedTextTitle === trimmedTextTitle) {
      setEditing(!editing);
      setTextTitle(trimmedTextTitle);
      return;
    }
    if (trimmedTextTitle === '') {
      setError(true);
      setErrorMsg(t2('ErrEmpty'));
      return;
    }
    setErrorMsg('');
    setError(false);

    updateAchievement({ id, name: trimmedTextTitle }).then(response => {
      setSavedTextTitle(trimmedTextTitle);
      setTextTitle(trimmedTextTitle);
    });

    setEditing(!editing);
  };

  const onChange = event => {
    setTextTitle(event.target.value);
  };

  return (
    <Card style={ContainerStyle}>
      <CardContent>
        <div>
          <TextField
            sx={{ height: 70 }}
            value={textTitle}
            disabled={!editing}
            className={!editing ? textFieldStyles.disabled : textFieldStyles.enabled}
            inputProps={{
              minLength: 1,
              maxLength: 50,
            }}
            error={error}
            helperText={errorMsg}
            onChange={onChange}
          />
          {editing ? (
            <IconContaniner onClick={handleSave}>
              <Save fontSize="medium" style={{ color: 'white' }} />
            </IconContaniner>
          ) : (
            <IconContaniner onClick={handleEdit}>
              <Edit fontSize="medium" style={{ color: 'white' }} />
            </IconContaniner>
          )}
        </div>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}
